import React from "react";
import { useSnapshot } from "valtio";
import PanIcon from "@assets/icons/pan.svg?react";
import MoveIcon from "@assets/icons/arrow-move.svg?react";
import EraserIcon from "@assets/icons/eraser.svg?react";
import LinePathIcon from "@assets/icons/line-path.svg?react";
import WardIcon from "@assets/icons/ward.svg?react";
import FileIcon from "@assets/icons/file.svg?react";
import { ArrowPathSvg } from "@assets/icons/ArrowPathSvg";
import { ShapesFactory } from "@shared/Map/objects/shapes/ShapesFactory";
import { toolState } from "@shared/states/uiStates";
import { MapTool } from "@shared/types/tools";

export const MobileToolIcon: React.FC<{ tool: MapTool; size?: number }> = ({
	tool,
	size = 32,
}) => {
	const toolSnap = useSnapshot(toolState);

	switch (tool) {
		case MapTool.PAN:
			return <PanIcon width={size} height={size} />;
		case MapTool.MOVE:
			return <MoveIcon width={size} height={size} />;
		case MapTool.ERASER:
			return <EraserIcon width={size} height={size} />;
		case MapTool.PENCIL:
			return toolSnap.properties[MapTool.PENCIL].isArrow ? (
				<ArrowPathSvg width={size} height={size} />
			) : (
				<LinePathIcon width={size} height={size} />
			);
		case MapTool.TEXT:
			return (
				<svg
					viewBox="0 0 256 256"
					width={size}
					height={size}
					xmlns="http://www.w3.org/2000/svg"
				>
					<text
						x={120}
						y={200}
						textAnchor={"middle"}
						fontSize={200}
						fill={"white"}
						fontWeight={200}
					>
						A
					</text>
				</svg>
			);
		case MapTool.SHAPE:
			return (
				<svg width={size} height={size} viewBox={"0 0 32 32"}>
					<ShapesFactory
						shape={toolSnap.properties[MapTool.SHAPE].shape}
						color={"transparent"}
						stroke={"white"}
					/>
				</svg>
			);
		case MapTool.IMAGE:
			return <FileIcon width={size} height={size} />;
		case MapTool.WARD:
			return <WardIcon width={size} height={size} />;
		default:
			return null;
	}
};
